import { useState, useEffect, useRef } from 'react';



export const useSelectMenuStatus = (scrollParent: HTMLElement = document.body as HTMLElement) => {
	const [menuIsOpen, setMenuIsOpen] = useState(false);
	const lastScrollTopRef = useRef(0);

	const SCROLL_THRESHOLD = 5; // pixels à parcourir avant de fermer le menu

	useEffect(() => {
		if (!scrollParent) return;

		const handleScroll = () => {
			const currentScrollTop = scrollParent.scrollTop;
			const delta = Math.abs(currentScrollTop - lastScrollTopRef.current);

			if (delta >= SCROLL_THRESHOLD) {
				setMenuIsOpen(false);
			}

			lastScrollTopRef.current = currentScrollTop;
		};

		scrollParent.addEventListener('scroll', handleScroll, true);

		return () => {
			scrollParent.removeEventListener('scroll', handleScroll, true);
		};
	}, [scrollParent]);

	const openMenu = () => setMenuIsOpen(true);

	const closeMenu = () => setMenuIsOpen(false);

	return { 
		scrollParent,
		menuIsOpen, 
		closeMenu,
		openMenu 
	};
};
